<template>
	<div class="c-file-picker">
		<div v-for="file in files" :key="file._id" class="c-file-picker__file">
			<div class="c-file-picker__file__inner">
				<h3>
					{{ file.title }}
				</h3>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		files: function () {
			return [
				{
					title: 'Homebase',
					_id: 1,
				},
				{
					title: 'Test',
					_id: 2,
				},
				{
					title: 'Test2',
					_id: 3,
				},
			];
		},
	},
};
</script>

<style lang="scss">
.c-file-picker {
	max-width: 560px;
	margin: 0 auto;
	display: grid;
	grid-template-columns: 50% 50%;
	grid-column-gap: 20px;
	grid-row-gap: 20px;
	justify-items: stretch;
	align-items: stretch;

	&__file {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 300px;
		border-radius: var(--border-radius);

		@include focus();

		&__inner {
			padding: var(--spacer-sm);
		}
	}
}
</style>